import styled from 'styled-components';

import { SIZES } from '../Base/Base.constants';
import { Base } from '../Base/Base';

export const PAGE_CONTENT_CONTAINER_PADDINGS = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
};
const PAGE_CONTENT_CONTAINER_PADDINGS_SEQUENCE = [
  PAGE_CONTENT_CONTAINER_PADDINGS.TOP,
  PAGE_CONTENT_CONTAINER_PADDINGS.RIGHT,
  PAGE_CONTENT_CONTAINER_PADDINGS.BOTTOM,
  PAGE_CONTENT_CONTAINER_PADDINGS.LEFT,
];
export const PAGE_CONTENT_CONTAINER_PADDING_PREFIX_VAR = '--page-content-container-padding-';
const DEFAULT_PAGE_CONTENT_CONTAINER_PADDING_VALUE = '20px';
const PAGE_CONTENT_CONTAINER_PADDING = PAGE_CONTENT_CONTAINER_PADDINGS_SEQUENCE.map((position) => {
  return `var(${PAGE_CONTENT_CONTAINER_PADDING_PREFIX_VAR}${position})`;
}).join(' ');

export const PageContent = styled(Base).attrs({ size: SIZES.M })`
  ${PAGE_CONTENT_CONTAINER_PADDINGS_SEQUENCE.map((position) => {
    return `${PAGE_CONTENT_CONTAINER_PADDING_PREFIX_VAR}${position}: ${DEFAULT_PAGE_CONTENT_CONTAINER_PADDING_VALUE};`;
  }).join(' ')}

  background-color: var(--color-white);

  box-sizing: border-box;
  padding: ${PAGE_CONTENT_CONTAINER_PADDING};

  border-radius: 16px;
`;
